<template>
    <section class="app-main" style="min-height: 100%">
        <transition name="fade-transform" mode="out-in">
            <!--<keep-alive>-->
            <router-view :key="key"></router-view>
            <!--</keep-alive>-->
        </transition>
    </section>
</template>

<script>
    export default {
        name: 'AppMain',
        computed: {
            key() {
                return this.$route.fullPath
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue